import React, { useMemo, useState } from "react";
import styled from "styled-components";
import { authType } from "../../../recoil/auth";
import LogController from "../../../controller/LogController";
import toast from "react-hot-toast";

interface HeaderProps {
  isOpenBar: boolean;
  setIsOpenBar: (isOpenBar: boolean) => void;
  setVisiblePushSetting: (visiblePushSetting: boolean) => void;
  isDetail: boolean;
  viewTypeToggle: () => void;
  isOpenCongestion: boolean;
  setIsOpenCongestion: (isOpenCongestion: boolean) => void;
  congestion: number;
  onChange_congestion: (congestion: number) => void;
  auth: authType;
  refreshAllOrder: (isComplete: number, bIsMuted?: boolean) => void;
}

const Header = ({
  isOpenBar,
  setIsOpenBar,
  setVisiblePushSetting,
  isDetail,
  viewTypeToggle,
  refreshAllOrder,
}: HeaderProps) => {
  const [rotationDegree, setRotationDegree] = useState<number>(0);

  const handleRotateClick = () => {
    setRotationDegree((prevDegree) => prevDegree - 360);
    refreshAllOrder(2, true);

    toast.success("주문 목록을 새로고침했어요");
  };

  const Header = useMemo(() => {
    return (
      <Style>
        <div className="header">
          <div className="headerLeft">
            <button onClick={() => setIsOpenBar(!isOpenBar)}>
              <img
                src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_hamburgerbar.svg`}
                alt="햄버거바"
              />
            </button>
            <button
              className="alarmButton"
              onClick={() => {
                setVisiblePushSetting(true);
                LogController.click({
                  path: "pushSetting button",
                  params: "알림설정 클릭",
                  params2: "",
                });
              }}
            >
              <img
                src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_alarm.svg`}
                alt="알림 아이콘"
              />
            </button>
            <button
              className="rotateButton"
              onClick={() => {
                handleRotateClick();
              }}
            >
              <img
                src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_refresh.svg`}
                alt="refresh"
                style={{
                  transform: `rotate(${rotationDegree}deg)`,
                  transition: "transform 1s ease",
                }}
              />
            </button>
          </div>
          <div className="headerRight">
            {/* <div className="congestionType">
            <div
              className="congestionHeader"
              onClick={() => oProps.setIsOpenCongestion(!oProps.isOpenCongestion)}
            >
              {oProps.congestion === 2
                ? "바쁨"
                : oProps.congestion === 1
                ? "보통"
                : "여유"}
              <img
                src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_arrow_down_black_small.svg`}
                alt="닫기"
              />
            </div>
            {oProps.isOpenCongestion && (
              <div className="congestionList">
                {oProps.congestion !== 2 && (
                  <div
                    className="congestionItem"
                    onClick={() => oProps.onChange_congestion(2)}
                  >
                    바쁨
                  </div>
                )}
                {oProps.congestion !== 1 && (
                  <div
                    className="congestionItem"
                    onClick={() => oProps.onChange_congestion(1)}
                  >
                    보통
                  </div>
                )}
                {oProps.congestion !== 0 && (
                  <div
                    className="congestionItem"
                    onClick={() => oProps.onChange_congestion(0)}
                  >
                    여유
                  </div>
                )}
              </div>
            )}
          </div> */}
            <div className="viewType">
              <button
                className={`detailButton ${!isDetail && "active"}`}
                onClick={viewTypeToggle}
              >
                간략히
              </button>
              <button
                className={`detailButton ${isDetail && "active"}`}
                onClick={viewTypeToggle}
              >
                자세히
              </button>
            </div>
          </div>
        </div>
      </Style>
    );
  }, [isDetail, rotationDegree]);

  return Header;
};
export default Header;

const Style = styled.div`
  /* header */
  .header {
    width: 100%;
    height: 40px;
    padding: 0 20px;
    background: #333333;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .headerLeft,
    .headerRight {
      display: flex;
      align-items: center;
      cursor: pointer;
    }
    .headerLeft {
      gap: 33px;
    }
    .headerRight {
      gap: 33px;

      .viewType {
        border-radius: 50px;
        background: #595959;
        .detailButton {
          height: 30px;
          padding: 0 19px;
          color: #a7a7a7;
          font-size: 16px;
          font-weight: 500;
        }
        .detailButton.active {
          background: #ffffff;
          color: #333333;
          border-radius: 50px;
        }
      }

      .congestionType {
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 90px;
        white-space: nowrap;
        color: #333333;
        .congestionHeader {
          width: 100%;
          height: 30px;
          background: #ffffff;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 50px;
          white-space: nowrap;
          font-size: 16px;
          font-weight: 600;
          z-index: 3;
          img {
            margin-left: 4px;
            margin-right: -24px;
          }
        }

        .congestionList {
          position: absolute;
          top: 50%;
          width: 100%;
          background: #595959;
          border: 1px solid #595959;
          color: #a7a7a7;
          border-radius: 0 0 15px 15px;
          display: flex;
          flex-direction: column;
          align-items: center;
          padding: 20px 0 10px 0;
          z-index: 2;

          .congestionItem {
            width: 100%;
            padding: 5px;
            font-weight: 600;
            font-size: 16px;
            line-height: 20px;
            border-radius: 15px;
            text-align: center;
          }
          .congestionItem:hover {
            background: #ffffff;
            color: #000000;
          }
        }
      }
    }
  }

  .rotateButton {
    padding: 0 4px;
    img {
      width: 24px;
      height: 24px;
    }
  }
`;
